<template>
<div class="sunmoon-widget p-2">
  <b-row>
    <b-col>
      <h2 class="text-center" title="Sunrise"><i class="wi wi-sunrise"></i></h2>
      <h5 class="text-center"><abbr :title="times['sunrise'].toFormat('fff')">{{ times['sunrise'].toFormat('t') }}</abbr></h5>
    </b-col>
    <b-col>
      <h2 class="text-center" title="Sunset"><i class="wi wi-sunset"></i></h2>
      <h5 class="text-center"><abbr :title="times['sunset'].toFormat('fff')">{{ times['sunset'].toFormat('t') }}</abbr></h5>
    </b-col>
    <b-col>
      <h2 class="text-center" title="Moonrise"><i class="wi wi-moonrise"></i></h2>
      <h5 class="text-center"><abbr :title="times['moonrise'].toFormat('fff')">{{ times['moonrise'].toFormat('t') }}</abbr></h5>
    </b-col>
    <b-col>
      <h2 class="text-center" title="Moonset"><i class="wi wi-moonset"></i></h2>
      <h5 class="text-center"><abbr :title="times['moonset'].toFormat('fff')">{{ times['moonset'].toFormat('t') }}</abbr></h5>
    </b-col>
    <b-col>
      <h2 class="text-center" title="Moon Phase"><i :class="'wi ' + getMoonIcon()"></i></h2>
      <h5 class="text-center">{{ times['moonphase'] }}</h5>
    </b-col>
  </b-row>
</div>
</template>

<script>
import {
  get
} from 'lodash'
import {
  DateTime
} from 'luxon'

export default {

  name: 'SunMoon',
  props: ["appdata", "options"],

  watch: {
    "appdata.response": function(val) {
      this.times["sunrise"] = DateTime.fromISO(this.ld.get(val, "weather.0.sun.sunrise", null))
      this.times["sunset"] = DateTime.fromISO(this.ld.get(val, "weather.0.sun.sunset", null))
      this.times["moonrise"] = DateTime.fromISO(this.ld.get(val, "weather.0.moon.moonrise", null))
      this.times["moonset"] = DateTime.fromISO(this.ld.get(val, "weather.0.moon.moonset", null))
      this.times["moonphase"] = this.ld.get(val, "weather.0.moon.phase_text", null)
    }
  },

  methods: {
    getMoonIcon() {
      switch (this.ld.get(this.appdata.response, "moon.phase_text", 'New Moon')) {
        case "New Moon":
          return "wi-moon-new"
        case "Waxing Crescent":
          return "wi-moon-waxing-crescent-3"
        case "First Quarter":
          return "wi-moon-first-quarter"
        case "Waxing Gibbous":
          return "wi-moon-waxing-gibbous-3"
        case "Full Moon":
          return "wi-moon-full"
        case "Waning Gibbous":
          return "wi-moon-waning-gibbous-3"
        case "Third Quarter":
          return "wi-moon-third-quarter"
        case "Waning Crescent":
          return "wi-moon-waning-crescent-3"
        default:
          return "wi-na"
      }
    }
  },

  data() {
    return {
      opts: {},
      ld: {
        get: _.get
      },
      DateTime: DateTime,
      times: {
        "sunrise": DateTime.fromISO('1970-01-01 00:00:00+00:00'),
        "sunset": DateTime.fromISO('1970-01-01 00:00:00+00:00'),
        "moonrise": DateTime.fromISO('1970-01-01 00:00:00+00:00'),
        "moonset": DateTime.fromISO('1970-01-01 00:00:00+00:00'),
        "moonphase": null
      }
    }
  }
}
</script>
